import { IConexaResponse, IEnumResponse } from '@/types'
import { ICouncilTypes } from './types'
import invoicingApi from '@/services/invoicingApi'
import coreApi from '@/services/coreApi'
import { GetCouncilListCoreMapper } from './mappers/getCouncilListCoreMapper'

class ShareService {
  static async getCouncilTypesListCore() {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>('/admin/council')

    return object.map(GetCouncilListCoreMapper.toDomain)
  }

  static async getCouncilTypesList(): Promise<ICouncilTypes[]> {
    const {
      data: { object },
    } = await invoicingApi.get<IConexaResponse<ICouncilTypes[]>>('council')

    return object
  }

  static async getSpecialtiesList(): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>('/admin/specialty')

    return object
  }

  static async getListUF(): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>('/user/uf')

    return object
  }

  static async getClinicConfig(clinicId: string | number) {
    const {
      data: { object },
    } = await coreApi.get(`clinica/config/backoffice/${clinicId}`)

    return object?.clinicaConfig
  }
}

export { ShareService }
